export class EmployeeSaveModel {
  identityId?: string;
  employerId?: string;
  memberId?: string;
  agentCode?: string;
}
